(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    module.exports = factory();
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function() {
  'use strict';

  /**
   * Utility methods for dealing with partial lists from the server..
   *
   * @class partialListUtils
   * @static
   */
  return {
    /**
     * Helper method to get the .list property from the response.
     *
     * @method convertPartialListResponseToList
     * @param response {Object} the response from the server
     *   @param response.list {Object[]} the list of items matching the criteria for the current page of results.
     * @return {Object[]} the list of items from the server.
     */
    convertPartialListResponseToList: function(response) {
      return response.list;
    }
  };
}));
